import React, { useEffect, useState, createElement } from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainPointsSection } from '../components/PainPointsSection';
import { BooksSection } from '../components/BooksSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { BonusSection } from '../components/BonusSection';
import { PricingSection } from '../components/PricingSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTA } from '../components/FinalCTA';
import { SocialProofPopup } from '../components/SocialProofPopup';
export function SalesPage() {
  const [showStickyCTA, setShowStickyCTA] = useState(false);
  useEffect(() => {
    // Meta Pixel Injection
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1379305313659580');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1379305313659580&ev=PageView&noscript=1" />`;
    document.head.appendChild(noscript);
    // Scroll listener for sticky CTA
    const handleScroll = () => {
      // Show sticky CTA after scrolling past hero section (approx 800px)
      if (window.scrollY > 800) {
        setShowStickyCTA(true);
      } else {
        setShowStickyCTA(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen bg-[#f0f7ff] font-sans overflow-x-hidden" data-id="element-311">
      <HeroSection data-id="element-312" />
      <PainPointsSection data-id="element-313" />
      <BooksSection data-id="element-314" />
      <BenefitsSection data-id="element-315" />
      <BonusSection data-id="element-316" />
      <PricingSection variant="compact" data-id="element-317" />
      <TestimonialsSection data-id="element-318" />
      <GuaranteeSection data-id="element-319" />
      <FAQSection data-id="element-320" />
      <PricingSection variant="full" data-id="element-321" />
      <FinalCTA data-id="element-322" />
      <SocialProofPopup data-id="element-323" />

      {/* Sticky Mobile CTA */}
      <div className={`fixed bottom-0 left-0 right-0 p-4 bg-white/90 backdrop-blur-md border-t border-gray-200 shadow-[0_-10px_20px_rgba(0,0,0,0.1)] z-40 md:hidden transition-transform duration-300 ${showStickyCTA ? 'translate-y-0' : 'translate-y-full'}`} data-id="element-324">
        <a href="https://payments.vantapro.shop/cart/45305094963302:1" target="_blank" rel="noopener noreferrer" className="w-full bg-orange-500 hover:bg-orange-600 text-white text-xl font-bold py-4 px-6 rounded-xl shadow-lg uppercase btn-pulse block text-center" data-id="element-325">
          🏆 ACCEDER AHORA AL KIT COMPLETO + EXTRAS
        </a>
      </div>
    </div>;
}